import { Link } from "react-router-dom";
import { Ban, HeartHandshake, Scale, ShieldAlert } from "lucide-react";
import { DISCLAIMER, aBtn } from "@/lib/adopt";

const BLOCKS = [
  [HeartHandshake, "Adopción responsable", [
    "Adoptar es un compromiso para toda la vida del animal: piensa en tu tiempo, tu espacio, tus gastos de cuidado y tus planes a futuro.",
    "Conoce al animal en persona antes de decidir y pregunta por su carácter, su salud y sus rutinas.",
    "Exige y entrega siempre la cartilla sanitaria y el microchip a nombre del nuevo responsable cuando la ley lo exija.",
    "Firmar un contrato de adopción y aceptar el seguimiento protege al animal y a las dos partes.",
  ]],
  [ShieldAlert, "Seguridad frente a estafas", [
    "Nunca envíes dinero por adelantado: ni «reservas», ni envíos, ni seguros, ni gastos de transporte.",
    "Desconfía de anuncios con fotos de catálogo, prisas o anunciantes que no permiten ver al animal.",
    "Habla siempre por la mensajería interna hasta conocer a la otra persona y queda en lugares seguros.",
    "Si algo no te encaja, denuncia el anuncio: lo revisaremos.",
  ]],
  [Ban, "Qué está prohibido", [
    "Cualquier venta, compra o petición de dinero: aquí solo se adopta.",
    "Especies protegidas, silvestres o prohibidas, y animales capturados en la naturaleza.",
    "Animales destinados a peleas, maltrato o cría sin control.",
    "Anuncios duplicados, engañosos o con datos falsos.",
  ]],
  [Scale, "Normativa", [
    "La tenencia de animales en España se rige por la Ley 7/2023 de protección de los derechos y el bienestar de los animales y por las normas de tu comunidad autónoma y tu ayuntamiento (identificación, registro, esterilización, seguro de responsabilidad civil, etc.).",
    "Los perros, gatos y hurones deben estar identificados con microchip y, cuando corresponda, inscritos en el registro autonómico.",
    "El transporte debe hacerse en condiciones de seguridad y bienestar; para viajes fuera de España necesitas el pasaporte europeo y los requisitos sanitarios del destino.",
    "Esta información es orientativa: consulta siempre la normativa vigente de tu comunidad.",
  ]],
];

export default function AdoptRules() {
  return (
    <div className="bg-[#FFF8F0] min-h-screen" data-testid="adopt-rules-page">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <p className="text-sm font-bold tracking-[0.2em] uppercase text-[#E07A5F]">FAUNNY Adopta</p>
        <h1 className="font-adopt text-4xl sm:text-5xl text-[#3D405B] mt-2">Consejos y normas</h1>
        <p className="text-[#3D405B] mt-4 max-w-2xl">{DISCLAIMER}</p>
        <div className="grid md:grid-cols-2 gap-5 mt-10">
          {BLOCKS.map(([Icon, title, items]) => (
            <section key={title} className="bg-white rounded-3xl p-6" data-testid={`rules-${title.split(" ")[0].toLowerCase()}`}>
              <Icon className="text-[#E07A5F]" size={28} />
              <h2 className="font-adopt text-2xl text-[#3D405B] mt-3">{title}</h2>
              <ul className="mt-3 space-y-2 text-[#3D405B] text-[15px] list-disc pl-5">{items.map((t) => <li key={t}>{t}</li>)}</ul>
            </section>
          ))}
        </div>
        <section className="bg-[#F2CC8F]/30 rounded-3xl p-6 mt-5 text-sm text-[#3D405B] space-y-2" data-testid="rules-privacy">
          <h2 className="font-adopt text-2xl">Privacidad (RGPD)</h2>
          <p>Tus datos de contacto no se muestran en los anuncios. Tu teléfono y tu email solo se comparten con la persona cuya solicitud aceptes. Puedes borrar tus anuncios y conversaciones cuando quieras. Más información en la <Link to="/legal/privacidad" className="font-bold underline">política de privacidad</Link>.</p>
          <p>FAUNNY ofrece este canal para poner en contacto a personas que quieren dar y adoptar animales. FAUNNY no es parte de las adopciones y no se responsabiliza de lo que cada persona haga fuera de este canal.</p>
        </section>
        <Link to="/adopcion" className={`${aBtn} mt-8`} data-testid="rules-back">Ver animales en adopción</Link>
      </div>
    </div>
  );
}
